export const translations = {
  en: {
      nav: { home: "Home", services: "Services", about: "About", reviews: "Reviews", gallery: "Gallery", contact: "Contact", login: "Portal Login", quote: "Free Quote" },
    hero: {
      eyebrow: "Top-Rated Moving Service",
      title1: "Relocate",
      title2: "With Confidence.",
      subtitle: "Professional care. Total trust. Serving Roselle, IL and the greater Chicago area.",
      cta: "Request Free Quote",
      cta2: "Call (331) 645-9072",
    },
    services: {
      title: "What We Move",
      subtitle: "From a single sofa to an entire office — we handle it with care.",
      items: [
        { name: "Local Moving", desc: "Under 50 miles. Fast, careful and on time." },
        { name: "Long Distance", desc: "Cross-state relocations, fully insured and tracked." },
        { name: "Office Moving", desc: "Weekend and after-hours business relocations." },
        { name: "Packing & Unpacking", desc: "Materials, boxes and expert wrapping included." },
        { name: "Furniture Assembly", desc: "Disassembly and reassembly by our crew." },
        { name: "Loading & Unloading", desc: "Labor-only options for rented trucks or PODS." },
      ],
    },
    about: {
      title: "About Flores On The Move",
      body: "Family-owned and Roselle-based, Flores On The Move LLC delivers reliable, insured and fully-professional moving services across Illinois. Chris Flores and his crew are known for meticulous packing, respectful care of heirloom pieces, and stress-free experiences from quote to unload.",
      badges: ["Fully Insured", "Top Rated on Thumbtack", "5-Star Google Reviews", "Bilingual Team (EN / ES)"],
    },
    reviews: { title: "Real Reviews", subtitle: "Verified customers from Thumbtack, Google and Facebook." },
    gallery: { title: "Our Work", subtitle: "A glimpse of moves we've handled with care.", empty: "Gallery coming soon." },
    contact: {
      title: "Ready To Move?",
      subtitle: "Get a free, no-obligation quote in minutes.",
      phone: "(331) 645-9072",
      email: "floresonthemovee@gmail.com",
      area: "Roselle, IL and surrounding Chicago suburbs",
      form: { name: "Your name", phone: "Phone", email: "Email", message: "Tell us about your move", submit: "Send Request" },
    },
    footer: { rights: "All rights reserved.", tagline: "Move smarter. Move with Flores." },
    login: {
      title: "Portal Access",
      subtitle: "Restricted area for Flores On The Move staff.",
      username: "Username",
      password: "Password",
      submit: "Sign in",
      back: "Back to website",
      error: "Invalid username or password",
    },
    portal: {
      brand: "Flores Portal",
      nav: { calendar: "Calendar", jobs: "Jobs", reports: "Reports", reviews: "Reviews", gallery: "Gallery", logout: "Log out" },
      welcome: "Welcome",
      addJob: "Add Job",
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      noJobs: "No jobs scheduled",
      job: {
        title: "New Job",
        editTitle: "Edit Job",
        client: "Client name",
        serviceType: "Service type",
        contact: "Client contact (phone / email)",
        addressFrom: "Move from (address)",
        addressTo: "Move to (address)",
        date: "Date",
        startTime: "Start time",
        endTime: "End time",
        deposit: "Deposit paid",
        total: "Total payment",
        expenses: "Expenses",
        expenseLabel: "Expense label",
        expenseAmount: "Amount",
        addExpense: "Add expense",
        notes: "Notes",
        status: "Status",
        save: "Save Job",
        delete: "Delete",
        cancel: "Cancel",
      },
      services: [
        "Local Moving (under 50 miles)",
        "Long Distance Moving",
        "Office / Commercial Moving",
        "Packing & Unpacking",
        "Loading Only",
        "Unloading Only",
        "Furniture Assembly",
        "Storage Move",
        "Special Item (Piano / Safe / Art)",
      ],
      statuses: ["scheduled", "completed", "cancelled"],
      reports: {
        title: "Financial Reports",
        subtitle: "Real-time accounting for your moves.",
        income: "Total Income",
        expenses: "Total Expenses",
        profit: "Net Profit",
        jobs: "Jobs Booked",
        monthly: "Monthly Performance",
        weekly: "Weekly Performance",
        byService: "Revenue by Service",
      },
    },
    common: { loading: "Loading...", currency: "USD" },
  },
  es: {
    nav: { home: "Inicio", services: "Servicios", about: "Nosotros", reviews: "Reseñas", gallery: "Galería", contact: "Contacto", login: "Portal Interno", quote: "Cotización" },
    hero: {
      eyebrow: "Servicio de Mudanza de Alta Calificación",
      title1: "Mudanzas",
      title2: "Con Confianza.",
      subtitle: "Cuidado profesional. Confianza total. Sirviendo Roselle, IL y el área de Chicago.",
      cta: "Cotización Gratis",
      cta2: "Llamar (331) 645-9072",
    },
    services: {
      title: "Lo Que Movemos",
      subtitle: "Desde un sofá hasta una oficina completa — lo manejamos con cuidado.",
      items: [
        { name: "Mudanzas Locales", desc: "Menos de 50 millas. Rápido, cuidadoso y a tiempo." },
        { name: "Larga Distancia", desc: "Mudanzas interestatales, aseguradas y rastreadas." },
        { name: "Mudanza de Oficina", desc: "Reubicaciones comerciales fines de semana y noches." },
        { name: "Empacar y Desempacar", desc: "Materiales, cajas y envoltura profesional incluidos." },
        { name: "Ensamblado de Muebles", desc: "Desarmado y armado por nuestro equipo." },
        { name: "Carga y Descarga", desc: "Solo mano de obra para camiones rentados o PODS." },
      ],
    },
    about: {
      title: "Acerca de Flores On The Move",
      body: "Empresa familiar con sede en Roselle, IL. Flores On The Move LLC ofrece servicios de mudanza confiables, asegurados y totalmente profesionales en Illinois. Chris Flores y su equipo son reconocidos por su cuidado meticuloso, respeto por objetos de valor y una experiencia sin estrés desde la cotización hasta la descarga.",
      badges: ["Totalmente Asegurados", "Top Rated en Thumbtack", "5 Estrellas en Google", "Equipo Bilingüe (EN / ES)"],
    },
    reviews: { title: "Reseñas Reales", subtitle: "Clientes verificados de Thumbtack, Google y Facebook." },
    gallery: { title: "Nuestros Trabajos", subtitle: "Un vistazo a las mudanzas que hemos manejado con cuidado.", empty: "Próximamente." },
    contact: {
      title: "¿Listo Para Mudarte?",
      subtitle: "Cotización gratis y sin compromiso en minutos.",
      phone: "(331) 645-9072",
      email: "floresonthemovee@gmail.com",
      area: "Roselle, IL y suburbios de Chicago",
      form: { name: "Tu nombre", phone: "Teléfono", email: "Correo", message: "Cuéntanos sobre tu mudanza", submit: "Enviar Solicitud" },
    },
    footer: { rights: "Todos los derechos reservados.", tagline: "Mudanzas inteligentes. Mudanzas con Flores." },
    login: {
      title: "Acceso al Portal",
      subtitle: "Área restringida para personal de Flores On The Move.",
      username: "Usuario",
      password: "Contraseña",
      submit: "Ingresar",
      back: "Volver al sitio",
      error: "Usuario o contraseña inválidos",
    },
    portal: {
      brand: "Portal Flores",
      nav: { calendar: "Calendario", jobs: "Trabajos", reports: "Reportes", reviews: "Reseñas", gallery: "Galería", logout: "Cerrar sesión" },
      welcome: "Bienvenido",
      addJob: "Agregar Trabajo",
      today: "Hoy",
      month: "Mes",
      week: "Semana",
      day: "Día",
      noJobs: "Sin trabajos programados",
      job: {
        title: "Nuevo Trabajo",
        editTitle: "Editar Trabajo",
        client: "Nombre del cliente",
        serviceType: "Tipo de servicio",
        contact: "Contacto del cliente (teléfono / correo)",
        addressFrom: "Dirección desde",
        addressTo: "Dirección hasta",
        date: "Fecha",
        startTime: "Hora inicio",
        endTime: "Hora fin",
        deposit: "Abono",
        total: "Pago total",
        expenses: "Gastos",
        expenseLabel: "Concepto del gasto",
        expenseAmount: "Monto",
        addExpense: "Agregar gasto",
        notes: "Notas",
        status: "Estado",
        save: "Guardar Trabajo",
        delete: "Eliminar",
        cancel: "Cancelar",
      },
      services: [
        "Mudanza Local (menos de 50 millas)",
        "Mudanza Larga Distancia",
        "Mudanza de Oficina / Comercial",
        "Empacado y Desempacado",
        "Solo Carga",
        "Solo Descarga",
        "Ensamblado de Muebles",
        "Mudanza a Almacenamiento",
        "Objeto Especial (Piano / Caja Fuerte / Arte)",
      ],
      statuses: ["programado", "completado", "cancelado"],
      reports: {
        title: "Reportes Financieros",
        subtitle: "Contabilidad en tiempo real de tus mudanzas.",
        income: "Ingreso Total",
        expenses: "Gastos Totales",
        profit: "Ganancia Neta",
        jobs: "Trabajos Realizados",
        monthly: "Rendimiento Mensual",
        weekly: "Rendimiento Semanal",
        byService: "Ingresos por Servicio",
      },
    },
    common: { loading: "Cargando...", currency: "USD" },
  },
};
